export const TYPES = {
  SET_DEFAULT_BANK_ALL: "default_bank/SET_DEFAULT_BANK_ALL",
  SET_DEFAULT_BANK_OPEN_ADD: "default_bank/SET_DEFAULT_BANK_OPEN_ADD",
  SET_DEFAULT_BANK_OPEN_EDIT: "default_bank/SET_DEFAULT_BANK_OPEN_EDIT",
  SET_DEFAULT_BANK_SELECTED: "default_bank/SET_DEFAULT_BANK_SELECTED",
  SET_DEFAULT_BANK_SEARCH: "default_bank/SET_DEFAULT_BANK_SEARCH",
  SET_DEFAULT_BANK_LAST: "default_bank/SET_DEFAULT_BANK_LAST",
};
